import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import WhatWeDoSection from '../components/WhatWeDoSection';
import WhyPlayfairSection from '../components/WhyPlayfairSection';
import Testimonials from '../components/Testimonials';
import Signup from '../components/Signup';

function HomePage() {
  return (
    <>
      <Helmet>
        <title>Playfair — The App for Sports by Players</title>
        <meta name="description" content="Playfair is the app built by players, for players. [Adjust to your real pitch.]" />
        <link rel="canonical" href="https://playfair.online/" />
      </Helmet>
      <Hero />
      <WhatWeDoSection />
      <WhyPlayfairSection />
      <Testimonials />
      <Signup />
    </>
  );
}

export default HomePage;
